/* SCHUTZHOUSE theme interactions — v3.0 */
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function initReveal(root) {
    var scope = root || document;
    var items = qsa('.reveal', scope);
    if (!items.length) return;

    /* In Shopify editor, never hide merchant content. */
    if (window.Shopify && Shopify.designMode) {
      items.forEach(function (el) {
        el.classList.remove('reveal-ready');
        el.classList.add('visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    items.forEach(function (el) { el.classList.add('reveal-ready'); });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -30px 0px', threshold: 0.03 });

    items.forEach(function (el) { observer.observe(el); });
  }

  function initHeader() {
    var header = qs('#SiteHeader');
    if (!header) return;
    function sync() { header.classList.toggle('at-top', window.scrollY < 8); }
    sync();
    window.addEventListener('scroll', sync, { passive: true });
  }

  function initSearch() {
    var overlay = qs('#SearchOverlay');
    var openBtn = qs('#SearchBtn');
    var closeBtn = qs('#SearchClose');
    if (!overlay || !openBtn) return;

    function open() {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var input = qs('input[type="search"]', overlay);
        if (input) input.focus();
      }, 50);
    }
    function close() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function initMobileMenu() {
    var panel = qs('#MobileMenu');
    var veil = qs('#MobileVeil');
    var openBtn = qs('#MobileMenuBtn');
    var closeBtn = qs('#MobileClose');
    if (!panel || !openBtn) return;

    function open() {
      panel.classList.add('on');
      if (veil) veil.classList.add('on');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      panel.classList.remove('on');
      if (veil) veil.classList.remove('on');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (veil) veil.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function initCart() {
    var panel = qs('#CartPanel');
    var veil = qs('#CartVeil');
    var openBtn = qs('#CartBtn');
    var closeBtn = qs('#CartClose');
    if (!panel || !openBtn) return;

    window.openCartPanel = function () {
      panel.classList.add('on');
      if (veil) veil.classList.add('on');
      document.body.style.overflow = 'hidden';
    };
    window.closeCartPanel = function () {
      panel.classList.remove('on');
      if (veil) veil.classList.remove('on');
      document.body.style.overflow = '';
    };
    window.updateCart = async function () {
      try {
        var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return;
        var cart = await res.json();
        ['CartCount','CartPanelCount'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.textContent = cart.item_count;
        });
      } catch (e) {}
    };

    openBtn.addEventListener('click', window.openCartPanel);
    if (closeBtn) closeBtn.addEventListener('click', window.closeCartPanel);
    if (veil) veil.addEventListener('click', window.closeCartPanel);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.closeCartPanel(); });
  }

  function initHero() {
    var visual = qs('#HeroVisual');
    var img = qs('#HeroImg');
    if (!visual || !img) return;
    if (img.complete) visual.classList.add('loaded');
    else img.addEventListener('load', function () { visual.classList.add('loaded'); }, { once: true });
  }

  function initAll(root) {
    initReveal(root || document);
    if (!root) {
      initHeader();
      initSearch();
      initMobileMenu();
      initCart();
      initHero();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
  });
})();
